import React, { useContext, useState } from "react";
import { Alert, Button } from "react-bootstrap";
import moment from "moment-timezone";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FileNameContext } from "../pages/Upload";
import { capWord, FormValuesForApiCall } from "../utils/types";
import { fullOrientation } from "../utils/orientation";
import colors from "../utils/colors";
import "./style.css";
import { upload } from "@testing-library/user-event/dist/upload";

const videoInfoList = [
  "camera",
  "date",
  "insight",
  "keywords",
  "location",
  "suburb",
  "name",
  "orientation",
  "postcode",
  // "provider",
  // "sensitivity",
  "street",
  "thumbnail",
];

interface VideoFormPropsType {
  uploadImage: FileList | undefined;
}

function VideoFormReview(props: VideoFormPropsType) {
  const { uploadImage } = props;
  console.log("uploadImage", uploadImage, typeof uploadImage);

  const { valuesForm, setShowReview, setSubmitStatus, setIsModalOpen } =
    useContext(FileNameContext);
  const navigate = useNavigate();

  const [progress, setProgress] = useState({ started: false, pc: 0 });
  const [msg, setMsg] = useState<string | null>(null);

  const timezone = "Australia/Sydney";
  const dateTimeInUtc = moment(valuesForm.date).tz(timezone).utc().format();
  const dateOnly = new Date(valuesForm.date);
  const keywordsArr = valuesForm.keywords.split(",");
  const locationArr = valuesForm.location.split(",");
  const locationArrNum = [Number(locationArr[0]), Number(locationArr[1])];
  function getRoughDate(date: Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${month}-${day}`;
  }

  const dataForApiCall: FormValuesForApiCall = {
    ...valuesForm,
    keywords: keywordsArr,
    date: dateTimeInUtc,
    dateRough: getRoughDate(dateOnly),
    videoPreviewURL: valuesForm.videoURL,
    duration: 15,
    locality: valuesForm.suburb,
    location: { type: "Point", coordinates: locationArrNum.reverse() },
    // coordinates: valuesForm.coordinates.reverse(),
    // location: { type: "Point", coordinates: [150.177224, -35.859735] },
  };

  delete dataForApiCall["submit"];
  delete dataForApiCall["suburb"];

  console.log("dataForApiCall", dataForApiCall);

  const getReadingDateTime = (date: string) => {
    const dateArr = date.split("T");
    return `${dateArr[0]} ${dateArr[1]}`;
  };

  const valuesToShowReview = {
    ...valuesForm,
    date: getReadingDateTime(valuesForm.date),
    sensitivity: "Public",
    provider: "SLS",
    orientation: fullOrientation(valuesForm.orientation),
  };

  const finalSubmitHandler = async () => {
    setSubmitStatus({
      status: "video_start",
      text: "Saving video information now...",
    });
    setIsModalOpen(true);
    const res = await axios.post(
      `${process.env.REACT_APP_create_video_api}`,
      dataForApiCall
      // {
      //   onUploadProgress: (progressEvent) => {
      //     console.log(progressEvent.progress! * 100);
      //     setProgress((prevState) => {
      //       return { ...prevState, pc: progressEvent.progress! * 100 };
      //     });
      //   },
      //   // headers: {
      //   //   "Custom-header": "value",
      //   // },
      // }
    );
    console.log("res", res);
    if (res.status === 201) {
      setSubmitStatus({
        status: "video_save_finish",
        text: "Video information has been saved.",
      });
      const videoId = res.data.data._id;
      if (!uploadImage) {
        console.log("No files selected");
      } else {
        setSubmitStatus({
          status: "video_thumb_save_start",
          text: "Start saving thumbnails now...",
        });
        const fd = new FormData();
        for (let i = 0; i < uploadImage.length; i++) {
          fd.append("file", uploadImage[i]);
        }
        // fd.append("files", uploadImage);
        setMsg("Uploading...");
        setProgress((prevState) => {
          return {
            ...prevState,
            started: true,
          };
        });
        const thumbnailApi = `${process.env.REACT_APP_create_video_api}/thumbnail/${res.data.data._id}`;
        axios
          .post(thumbnailApi, fd, {
            onUploadProgress: (progressEvent) => {
              console.log(progressEvent.progress! * 100);
              setProgress((prevState) => {
                return { ...prevState, pc: progressEvent.progress! * 100 };
              });
            },
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            console.log(res.data, res);
            if (res.status === 200) {
              setSubmitStatus({
                status: "video_thumb_save_finish",
                text: "Video thumbnails have been saved,now redirecting to preview page...",
              });
            }

            setMsg("Upload successfully");
          })
          .catch((err) => {
            console.error(err);
            setMsg("Upload failed");
          });
      }

      axios
        // Faceblur service base; falls back to the legacy port-on-same-host form.
        .get(`${process.env.REACT_APP_FACEBLUR_URL || `${process.env.REACT_APP_SMODS_URL}:4022`}/video?id=${videoId}`)
        .then((res) =>
          console.log(res.data, "previewURL has been added successfully")
        )
        .catch((err) => console.error(err));
      console.log("videoID", videoId);

      setTimeout(() => {
        setIsModalOpen(false);
        navigate(`/sls/upload/preview/${videoId}`);
      }, 2000);
    }
  };

  return (
    <div className="review">
      <Alert className="my-3 text-center" variant="primary">
        <div className="alert-message" style={{ fontSize: "18px" }}>
          <strong>Step 3 : </strong>Please review your form information:
        </div>
      </Alert>
      <div style={{ padding: "5px 20px" }}>
        {videoInfoList.map((each, index) => {
          if (each === "thumbnail") {
            return (
              <div className="reviewText" key={index}>
                <strong>{capWord(each)}</strong> :{" "}
                {/* <p>{uploadImage && uploadImage[0].name}</p>
                <p>{uploadImage && uploadImage[1].name}</p> */}
                <div>
                  {uploadImage &&
                    Object.values(uploadImage).map((each: any, index) => (
                      <div key={index} style={{ textAlign: "left" }}>
                        <p style={{ marginLeft: "30px" }}>
                          Image {index + 1} : {each.name}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            );
          }
          return (
            <div className="reviewText">
              <strong>{capWord(each)}</strong> :{" "}
              <p style={{ marginLeft: "30px" }}>
                {(valuesToShowReview as any)[each]}
              </p>
            </div>
          );
        })}
      </div>

      <div style={{ marginBottom: "20px" }}>
        <Button
          type="submit"
          variant="success"
          size="lg"
          className="login-btn"
          style={{ marginRight: "30px", background: colors.SLSsecondary }}
          onClick={finalSubmitHandler}
        >
          Submit now
        </Button>
        <Button
          size="sm"
          variant="warning"
          className="login-btn"
          style={{
            marginRight: "30px",
            background: colors.SLSprimary,
            color: "white",
          }}
          onClick={() => {
            setShowReview(false);
          }}
        >
          Edit the form
        </Button>
      </div>
    </div>
  );
}

export default VideoFormReview;
